import { Component } from '@angular/core';

import { DashboardTransactionsActivityStore } from '../stores/dashboard-transactions-activity.store';

@Component({
  selector: 'app-transactions-activity',
  standalone: false,
  templateUrl: './transactions-activity.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
  ],
  providers: [ DashboardTransactionsActivityStore ],
})
export class TransactionsActivityComponent {

  viewModel$ = this.activityStore.viewModel$;

  constructor(
    private readonly activityStore: DashboardTransactionsActivityStore,
  ) {}

}
